import styled from 'styled-components';

export const SuggestionsContainer = styled.div`
  position: absolute;
  background: #fff;
  width: 100%;
  margin-top: 1.5rem;
  box-shadow: 0px 20px 35px -20px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
`;

export const SuggestionsList = styled.ul`
  list-style: none;
`;

export const SuggestionsItem = styled.li`
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 1rem 2rem;
    img {
      height: 4rem;
      width: auto;
      margin-right: 2rem;
    }
    &:hover {
      background-color: #f7f7f7;
    }
  }
`;
